/**
 * CORS Configuration for Axios Requests
 * Provides proper headers to avoid CORS issues with ngrok backend
 */
export const corsConfig = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers":
      "Origin, Content-Type, Accept, Authorization, X-Requested-With",
  },
  timeout: 10000,
  withCredentials: false, // Explicitly disable to avoid CORS credential issues
};

/**
 * Alternative CORS configuration for development
 * This is more permissive and includes common CORS headers
 */
export const devCorsConfig = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, PATCH, OPTIONS",
    "Access-Control-Allow-Headers":
      "Origin, Content-Type, Accept, Authorization, X-Requested-With, Cache-Control",
    "Access-Control-Max-Age": "86400",
  },
  timeout: 15000,
  withCredentials: false,
};
